import {
  MediaType,
  Children,
  ListInstagramAccountMediaResponse,
} from '@wix/ambassador-instagram-feed-v1-instagram-media/types';
import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { WidgetPropsI } from '../../types';
import { addDimensionsToMedia } from './helper';

export interface PgItemType {
  type: 'image' | 'video' | 'carousel';
  description: string;
  alt: string;
  src: string;
  thumbnail?: string;
  link: string;
  timestamp: Date;
  children?: any[];
  width?: number;
  height?: number;
}

export interface ConvertMediaOptions {
  isChildren?: boolean;
  addDimensions?: boolean;
  props?: WidgetPropsI;
  flowAPI?: PlatformControllerFlowAPI;
}

export const convertMediasToPG = (
  instaMedia,
  options: ConvertMediaOptions = {},
): PgItemType[] => {
  const { isChildren = false, addDimensions = false, props, flowAPI } = options;
  isChildren
    ? (instaMedia as Children[])
    : (instaMedia as ListInstagramAccountMediaResponse);
  instaMedia = isChildren ? instaMedia : instaMedia.media;
  const items = instaMedia?.map((item?) => {
    const {
      timestamp,
      mediaType,
      caption: description,
      permalink: link,
      mediaUrl,
      thumbnailUrl,
    } = item;

    switch (mediaType as MediaType) {
      case MediaType.IMAGE:
        return {
          type: 'image',
          description,
          alt: description,
          src: mediaUrl,
          link,
          timestamp,
        } as PgItemType;
      case MediaType.VIDEO:
        return {
          type: mediaUrl ? 'video' : 'image',
          description,
          alt: description,
          src: mediaUrl ?? thumbnailUrl,
          thumbnail: thumbnailUrl,
          link,
          timestamp,
        } as PgItemType;
      case MediaType.CAROUSEL_ALBUM: {
        const children = convertMediasToPG(item?.children, {
          isChildren: true,
          addDimensions,
          props,
          flowAPI,
        });
        let src = mediaUrl;
        if (!src && Array.isArray(item?.children) && item.children.length > 0) {
          src = item.children.find(
            (child) => child && child.mediaUrl,
          )?.mediaUrl;
        }
        return {
          type: 'carousel',
          description,
          alt: description,
          src,
          link,
          timestamp,
          children,
        } as PgItemType;
      }
      case MediaType.UNKNOWN:
      default:
        return {} as PgItemType;
    }
  });

  // Add dimensions if flag is true and required parameters are provided
  if (addDimensions && props && flowAPI && !isChildren) {
    return addDimensionsToMedia(items, props, flowAPI);
  }

  return items;
};

// Create a carousel from every media type so user will see the arrows to customize
export const createCarousel = (media: PgItemType): PgItemType => {
  if (media.type !== 'carousel') {
    const albumImageSrc = media.type === 'image' ? media.src : media.thumbnail;
    media.children = [
      { type: 'image', src: albumImageSrc },
      { type: 'image', src: albumImageSrc },
    ];
    media.type = 'carousel';
  }
  return media;
};
